"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const GROWTH_BOOK_1 = __importStar(require("../../constants/app/GROWTH_BOOK"));
const initGrowthBookClient_1 = __importDefault(require("./initGrowthBookClient"));
const initGrowthBookServer_1 = __importDefault(require("./initGrowthBookServer"));
// TODO: remove after merging sentry API and get NEXT_PUBLIC_APP_ENV
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const createGrowthBook = (appEnv) => {
    const growthBookOptions = {
        apiHost: GROWTH_BOOK_1.apiHost,
        clientKey: GROWTH_BOOK_1.default[appEnv || 'local'],
        enableDevMode: appEnv !== 'production',
    };
    const isServer = typeof window === 'undefined';
    if (isServer) {
        return (0, initGrowthBookServer_1.default)(growthBookOptions);
    }
    return (0, initGrowthBookClient_1.default)(growthBookOptions);
};
exports.default = createGrowthBook;
